import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_HOW_TO_APPLY_START, POST_HOW_TO_APPLY_ERROR, POST_HOW_TO_APPLY_START, POST_HOW_TO_APPLY_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/how-to-apply/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    // yield put({ type: POST_OUR_WORK_SUCCESS, results: results.data });
    yield put({type: POST_HOW_TO_APPLY_SUCCESS, results: results.data});
  } catch (error) {
    console.log(error)
    yield put({type: POST_HOW_TO_APPLY_ERROR, error});
  } finally {
    yield put({ type: GET_HOW_TO_APPLY_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* post_how_to_apply() {
  yield takeLatest(POST_HOW_TO_APPLY_START, create);
}